<template>
  <!-- https://getbootstrap.com/docs/4.0/utilities/position/ -->
  <div class="pl-4 pt-4 pb-4 sticky-top" :class="{ myrundash: !team || team == 'myrundash', MDI: team == 'MDI' || ($router.history.current.path =='/marathondynamics') }">
    <h3 @click="setActiveTab('')"><router-link to="/" class="">MyRunDash</router-link></h3>
    <img src="../../assets/img/icons/Hamburger_icon.svg" alt="" width="30px" v-on:click="show = !show" style="float: ;" class="pt-1">
    <!-- <div class="row">
      <div class="col-sm-8">
        <h3 @click="setActiveTab('')"><router-link to="/" class="">MyRunDash</router-link></h3>
      </div>
      <div class="col-sm-4 pr-4">
        <img src="../../assets/img/icons/Hamburger_icon.svg" alt="" width="30px" v-on:click="show = !show" style="float: right;">
      </div>
    </div> -->
    <!-- <hr> -->
    <div class="accordion mt-2">
      <!-- <div class="header" style="padding-left: 12px;" v-on:click="show = !show"> -->
        <!-- <slot name="header">+ Add Race</slot> -->
        <!-- <img src="../../assets/img/icons/Hamburger_icon.svg" alt="" width="30px"> -->
      <!-- </div> -->
      <transition name="accordion"
        v-on:before-enter="beforeEnter" v-on:enter="enter"
        v-on:before-leave="beforeLeave" v-on:leave="leave">
        <div class="body" v-show="show" style="background-color: var(--coredarkcolor)">
          <div class="body-inner" style="padding-top: 3px;; padding-bottom: 0; padding-right: 0; padding-left: 0;">

            <div>
              <div v-if="auth" :class="{ 'active-tab': activetab == 'dashboard' }" class="tab-div">
                <router-link to="/dashboard" class="sidebar-link"><h3 @click="setActiveTab('dashboard')">Dashboard</h3></router-link>
              </div>
              <div v-if="auth" :class="{ 'active-tab': activetab == 'training' }" class="tab-div">
                <router-link to="/trainingplan" class="sidebar-link"><h3 v-if="auth" @click="setActiveTab('training')">Training Plan</h3></router-link>
              </div>
              <div v-if="auth" :class="{ 'active-tab': activetab == 'racelog' }" class="tab-div">
                <router-link to="/racelog" class="sidebar-link"><h3 v-if="auth" @click="setActiveTab('racelog')">Race Log</h3></router-link>
              </div>
              <div v-if="auth" :class="{ 'active-tab': activetab == 'raceplan' }" class="tab-div">
                <router-link to="/raceplanner" class="sidebar-link"><h3 v-if="auth" @click="setActiveTab('raceplan')">Race Planner</h3></router-link>
              </div>
              <div v-if="auth" :class="{ 'active-tab': activetab == 'userprofile' }" class="tab-div">
                <router-link to="/profile" class="sidebar-link"><h3 v-if="auth" @click="setActiveTab('userprofile')">My Profile</h3></router-link>
              </div>
              <div v-if="auth" :class="{ 'active-tab': activetab == 'buddyfinder' }" class="tab-div">
                <router-link :to="{ name: 'Buddy Finder' }" class="sidebar-link"><h3 v-if="auth" @click="setActiveTab('buddyfinder')">Run Buddy Finder</h3></router-link>
              </div>
              <div v-if="auth" class="tab-div">
                <router-link to="" class="sidebar-link"><h3 v-if="auth" @click="onLogout" class="sidebar-link" :class="{ 'active-tab': activetab == 'logout' }">Logout</h3></router-link>
              </div>
              <div v-if="!auth" :class="{ 'active-tab': activetab == 'signin' }" class="tab-div">
                <router-link to="/login" class="sidebar-link"><h3 v-if="!auth" @click="setActiveTab('signin')">Sign In</h3></router-link>
              </div>
              <div v-if="!auth" :class="{ 'active-tab': activetab == 'signup' }" class="tab-div">
                <router-link to="/register" class="sidebar-link"><h3 v-if="!auth" @click="setActiveTab('signup')">Sign Up</h3></router-link>
              </div>
            </div>

          </div>
        </div>
      </transition>
    </div>


  </div>
</template>

<script>
  export default {
    data () {
      return {
        show: false,
        activetab: '',
      }
    },
    computed: {
      auth () { // Lecture 363
        return this.$store.getters.isAuthenticated
      },
      // activetab () {
      //   return this.$store.getters.menuState
      // }
      team () {
        if (this.$store.getters.team) {
          return this.$store.getters.team
        }
        else {
          return ''
        }
      },
    },
    methods: {
      onLogout() {
        this.activetab = 'signin'
        this.$store.dispatch('logout')
      },
      setActiveTab(tab) {
        this.activetab = tab
        // this.$store.dispatch('setMenuState', { menuState: tab })
        // this.activetab = this.$store.getters.menuState
      },

      /* ---- accordion ---- */
      beforeEnter: function(el) {
        el.style.height = '0';
      },
      enter: function(el) {
        el.style.height = el.scrollHeight + 'px';
      },
      beforeLeave: function(el) {
        el.style.height = el.scrollHeight + 'px';
      },
      leave: function(el) {
        el.style.height = '0';
      },
      /* ---- End of Accordion methods --- */
    },
  }
</script>

<style scoped>
  a {
    color: #fff;
  }
  a:hover {
    /* text-transform: none; */
    text-decoration: none;
  }

  .sidebar-link h3 {
    color: #fff;
    text-transform: uppercase;
    font-size: 18px;
    /* font-weight: 900; */
    /* font-family: 'Open Sans', sans-serif; */
    /* font-weight: 800; */
    /* font-weight: 700; */
    /* text-align: right; */
  }

  .tab-div {
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 1px;
  }
  .tab-div:hover {
    cursor: pointer;
  }
  .active-tab {
    /* color: green; */
    background: #5e8dad;
    /* color: #183a52; */
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    /* padding-left: 10px; */
    /* padding-top: 4px; */

  }
  .router-link-exact-active {
    /* background: #fff;
    color: #183a52;
    padding-left: 10px;
    padding-top: 4px;
    padding-bottom: 8px; */
    /* font-size: 18px;
    font-weight: 700 */
  }
</style>



// WEBPACK FOOTER //
// src/components/myrundash/MobileSidebar.vue